/*************************************************/
/* MMENU                                         */
/*************************************************/
import Mmenu from 'mmenu-js';

export function mmenu() {
    let mobileMenu,
        mobileMenuTrigger;

    const mobileMenuSelector = '#mobile-menu',
        mainContentSelector = '#mainContent';

    const init = function () {
        mobileMenu = document.querySelector(mobileMenuSelector);
        mobileMenuTrigger = document.querySelector('.mm-trigger');

        //Init mmenu
        const menu = new Mmenu(mobileMenuSelector, {
            
            slidingSubmenus: true,
            "extensions": [
                "position-right",
                "pagedim-black",
                "border-full",
                "theme-dark"
            ],
            offCanvas: {
                use: true,
                position: "right"
            }
        }, {
            offCanvas: {
                page: {
                    nodeType: "main",
                    selector: mainContentSelector
                }
            }
        });
        const mmenuApi = menu.API;

        // Open menu
        mobileMenuTrigger.addEventListener('click', () => {
            if (mmenuApi) {
                mobileMenu.setAttribute('style', '');
                mmenuApi.open();
            }
        });

        // Close mmenu if screen width gets over breakpoint
        var mediaQuery = window.matchMedia("(min-width: 768px)");
        mediaQuery.addEventListener("change", function () {
            if (mmenuApi) {
                mmenuApi.close();
            }
        });
    };

    init();
}
